import { get } from 'lodash'
import api from 'shared/api'

const basePageSize = 20

const transformSearchFilter = (query, queryType) => {
  if (!query) return ''
  const finalQuery = `&${queryType}=${query.trim()}`
  return finalQuery
}

// Get Device Users list
export const getDevices = (
  companyId,
  page = 0,
  query,
  queryType,
  orderBy,
  pageSize = basePageSize,
  filters = null
) => {
  const blacklistedNull =
    get(filters, 'blacklisted.value') === null || get(filters, 'blacklisted.value') === undefined
  const blacklistedQuery = blacklistedNull
    ? ''
    : `&blacklisted=${get(filters, 'blacklisted.value')}`
  const queryUrl = transformSearchFilter(query, queryType)
  const orderUrl = orderBy
    ? `&order_by=${orderBy.map(orderType => `${orderType.desc ? '-' : ''}${orderType.id}`)}`
    : ''
  const url = `/api/v1/devices/?company=${companyId}&limit=${pageSize}&offset=${
    page ? page * pageSize : 0
  }${orderUrl}${queryUrl}${blacklistedQuery}`
  return api.get(url)
}

export const getDeviceDetails = (deviceID, companyId) => {
  return api.get(`/api/v1/devices/${deviceID}/?company=${companyId}`)
}

export const resetDevice = (deviceID, companyId) => {
  return api.post(`/api/v1/devices/${deviceID}/reset/?company=${companyId}`)
}

export const blacklistDevice = (deviceID, companyId) => {
  return api.post(`/api/v1/devices/${deviceID}/blacklist/?company=${companyId}`)
}

export const whitelistDevice = (deviceID, companyId) => {
  return api.post(`/api/v1/devices/${deviceID}/whitelist/?company=${companyId}`)
}

export const bulkDeviceReset = (companyId, data) => {
  return api.post(`/api/v1/devices/reset_bulk/?company=${companyId}`, data)
}

export const bulkDeviceBlacklist = (companyId, data) => {
  return api.post(`/api/v1/devices/blacklist_bulk/?company=${companyId}`, data)
}

export const bulkDeviceWhitelist = (companyId, data) => {
  return api.post(`/api/v1/devices/whitelist_bulk/?company=${companyId}`, data)
}

export const getLicenseUserDevices = (companyId, licenseUserID) => {
  return api.get(`/api/v1/devices/?company=${companyId}&license_users__id=${licenseUserID}`)
}

export const getCustomerAccountDevices = (companyId, customerAccountID) => {
  return api.get(
    `/api/v1/devices/?company=${companyId}&license__order__customer_account=${customerAccountID}`
  )
}
